import React from 'react';
import './Wgoareyoulooking.css';  // Import the CSS file

const HeroSection = () => {
    return (
        <div className="hero-section">
            {/* Overlay div */}
            <div className="hero-section-overlay"></div>

            {/* Main content */}
            <h1>What Are You Looking For?</h1>
            <div className="hero-section-cards">
                {/* Apartment Card 1 */}
                <div className="hero-section-card">
                    <h3>Residential</h3>
                    <p>
                    Invest in premium residential properties with high returns. Find homes in prime locations, offering comfort, security, and a great lifestyle for you and your family.
                    </p>
                    
                </div>

                {/* Duplicate for 2nd and 3rd Cards */}
                <div className="hero-section-card">
                    <h3>Commercial</h3>
                    <p>
                    Explore high-value commercial properties in prime locations. Whether you need office space, retail outlets, or industrial units, our listings offer excellent investment opportunities.
                    </p>
                   
                </div>

                
            </div>
        </div>
    );
};

export default HeroSection;
